export const downloadBlob = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");

  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();

  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

export const downloadBase64File = (fileName: string, base64Data: string) => {
  const link = document.createElement("a");
  link.href = `data:text/csv;base64,${base64Data}`;
  link.download = fileName;
  link.click();
};

/** Default filename when Content-Disposition is missing. */
export const AGENT_PERFORMANCE_EXPORT_FILENAME =
  "agent_performance_report.xlsx";

export const generateDownloadFilename = (
  base: string,
  downloadMode: "single" | "all" | "single_summary",
  format: "txt" | "md" | "pdf",
) => {
  const now = new Date();

  const pad = (n: number) => String(n).padStart(2, "0");

  const date = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(
    now.getDate(),
  )}`;

  const time = `${pad(now.getHours())}-${pad(now.getMinutes())}-${pad(
    now.getSeconds(),
  )}`;

  return `${base}-${downloadMode}-${date}_${time}.${format}`;
};
